import {
  getReq,
  postReq,
  deleteSendReq,
  putReq,
  getCPHeaderMap,
  getHeaderCodeMap,
  END_POINTS
} from '@/api'
import * as Utils from '@/utils'

// const baseUrl = process.env.BASE_URL

const state = {
  ctrAcctSearchInfo: {
    acctName: '',
    compId: '',
    type: '',
    status: ''
  },
  ctrAcctListObject: {
    ctrAcctList: [],
    currentPage: 1,
    pageSize: 10,
    total: 0,
    totalPage: 0
  },
  ctrAcctInfo: {
    ctrAcctId: '',
    acctName: '',
    acctDesc: '',
    compId: '',
    acctContact: '',
    type: '',
    status: '',
    crtBy: '',
    crtOn: 0,
    updBy: '',
    updOn: 0,
    // ,
    indUsed: ''
    // extCompName: ''
  },
  ctrAcctDDList: [],
  END_STATE: null
}

const getters = {

}

const actions = {
  async insertCtrAcct({
    dispatch,
    commit,
    state
  }, {codeParam}) {
    // debugger
    const insertObj = await postReq(END_POINTS.INSERT_RSP_CTR_ACCT, {
      data: {
        acctName: state.ctrAcctInfo.acctName,
        acctDesc: state.ctrAcctInfo.acctDesc,
        compId: state.ctrAcctInfo.compId,
        acctContact: state.ctrAcctInfo.acctContact,
        type: state.ctrAcctInfo.type,
        status: state.ctrAcctInfo.status
      },
      headerMap: await getCPHeaderMap(state.ctrAcctInfo.compId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return insertObj
  },
  async updateCtrAcct({
    dispatch,
    commit,
    state
  }, {ctrAcctId, compId, codeParam}) {
    let ctrAcctInfo = {
      acctName: state.ctrAcctInfo.acctName,
      acctDesc: state.ctrAcctInfo.acctDesc,
      acctContact: state.ctrAcctInfo.acctContact,
      type: state.ctrAcctInfo.type,
      status: state.ctrAcctInfo.status,
      //
      ctrAcctId: ctrAcctId,
      compId: compId
    }
    const updateObject = await putReq(END_POINTS.UPDATE_RSP_CTR_ACCT, {
      data: ctrAcctInfo,
      headerMap: await getCPHeaderMap(compId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async removeCtrAcct({
    commit,
    state
  }, {ctrAcctId, compId, codeParam}) {
    const deleteObject = await deleteSendReq(END_POINTS.REMOVE_RSP_CTR_ACCT + `?ctrAcctId=${ctrAcctId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return deleteObject
  },
  async findCtrAcct({
    commit
  }, {ctrAcctId, compId, codeParam}) {
    const responseData = await getReq(END_POINTS.FIND_RSP_CTR_ACCT + `?ctrAcctId=${ctrAcctId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    if (responseData.success) {
      commit('updateCtrAcctInfo', responseData.data)
    } else {
      commit('updateCtrAcctInfo', {})
    }
  },
  async findCtrAcctCondition({
    commit,
    state,
    rootState
  }, { currentPage, pageSize, codeParam }) {
    let stateCurrentPage = currentPage
    if (pageSize) {
      state.ctrAcctListObject.pageSize = pageSize
      stateCurrentPage = 1
    }
    const ctrAcctListObject = await postReq(END_POINTS.FIND_RSP_CTR_ACCT_CONDITION, {
      data: {
        currentPage: stateCurrentPage,
        orderBy: '',
        pageSize: state.ctrAcctListObject.pageSize,
        queryVO: {
          acctName: state.ctrAcctSearchInfo.acctName,
          compId: state.ctrAcctSearchInfo.compId,
          type: state.ctrAcctSearchInfo.type,
          status: state.ctrAcctSearchInfo.status
        },
        refreshTotalRecord: true
      },
      headerMap: await getCPHeaderMap(state.ctrAcctSearchInfo.compId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateCtrAcctListObject', ctrAcctListObject)
  },
  async findRspCtrAcctDDList({
    commit,
    state
  }, { compId, codeParam }) {
    // debugger
    const responseData = await getReq(END_POINTS.FIND_RSP_CTR_ACCT_DD_LIST + `?compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    if (responseData.success) {
      commit('updateCtrAcctDDList', responseData.data)
    } else {
      commit('updateCtrAcctDDList', [])
    }
  },
  addCtrAcctDDItem({
    commit,
    state
  }, value) {
    commit('appendCtrAcctDDItem', value)
  },
  END_ACTIONS() {}
}

const mutations = {
  updateSearchAcctName(state, value) {
    state.ctrAcctSearchInfo.acctName = value
  },
  updateSearchCompId(state, value) {
    state.ctrAcctSearchInfo.compId = value
  },
  updateSearchType(state, value) {
    state.ctrAcctSearchInfo.type = value
  },
  updateSearchStatus(state, value) {
    state.ctrAcctSearchInfo.status = value
  },
  //
  updateAcctName(state, value) {
    state.ctrAcctInfo.acctName = value
  },
  updateAcctDesc(state, value) {
    state.ctrAcctInfo.acctDesc = value
  },
  updateCompId(state, value) {
    state.ctrAcctInfo.compId = value
  },
  updateAcctContact(state, value) {
    state.ctrAcctInfo.acctContact = value
  },
  updateType(state, value) {
    state.ctrAcctInfo.type = value
  },
  updateStatus(state, value) {
    state.ctrAcctInfo.status = value
  },
  //
  updateCtrAcctListObject(state, ctrAcctListObject) {
    if (ctrAcctListObject.code === 2001) {
      state.ctrAcctListObject.ctrAcctList = ctrAcctListObject.data.map(value => {
        return {
          ctrAcctId: value.ctrAcctId,
          acctName: value.acctName,
          acctDesc: value.acctDesc,
          compId: value.compId,
          acctContact: value.acctContact,
          type: value.type,
          status: value.status,
          crtBy: value.crtBy,
          crtOn: value.crtOn,
          updBy: value.updBy,
          updOn: value.updOn,
          // ,
          indUsed: value.indUsed
          // extCompName: value.extCompName
        }
      })
      state.ctrAcctListObject.currentPage = ctrAcctListObject.currentPage
      state.ctrAcctListObject.pageSize = ctrAcctListObject.pageSize
      state.ctrAcctListObject.total = ctrAcctListObject.total
      state.ctrAcctListObject.totalPage = ctrAcctListObject.totalPage
    } else {
      state.ctrAcctListObject.ctrAcctList = []
      state.ctrAcctListObject.total = 0
    }
  },
  updateCtrAcctEmpty(state) {
    state.ctrAcctInfo.ctrAcctId = ''
    state.ctrAcctInfo.acctName = ''
    state.ctrAcctInfo.acctDesc = ''
    state.ctrAcctInfo.compId = ''
    state.ctrAcctInfo.acctContact = ''
    state.ctrAcctInfo.type = ''
    state.ctrAcctInfo.status = ''
    state.ctrAcctInfo.crtBy = ''
    state.ctrAcctInfo.crtOn = 0
    state.ctrAcctInfo.updBy = ''
    state.ctrAcctInfo.updOn = 0
    //
    state.ctrAcctInfo.indUsed = ''
    // state.ctrAcctInfo.extCompName = ''
  },
  updateCtrAcctInfo(state, ctrAcctInfo) {
    // debugger
    // state.ctrAcctInfo.ctrAcctId = ctrAcctInfo.ctrAcctId
    state.ctrAcctInfo.acctName = ctrAcctInfo.acctName
    state.ctrAcctInfo.acctDesc = ctrAcctInfo.acctDesc
    state.ctrAcctInfo.compId = ctrAcctInfo.compId
    state.ctrAcctInfo.acctContact = ctrAcctInfo.acctContact
    state.ctrAcctInfo.type = ctrAcctInfo.type
    state.ctrAcctInfo.status = ctrAcctInfo.status
    state.ctrAcctInfo.crtBy = ctrAcctInfo.crtBy
    state.ctrAcctInfo.crtOn = ctrAcctInfo.crtOn
    state.ctrAcctInfo.updBy = ctrAcctInfo.updBy
    state.ctrAcctInfo.updOn = ctrAcctInfo.updOn
    //
    state.ctrAcctInfo.indUsed = ctrAcctInfo.indUsed
    // state.ctrAcctInfo.extCompName = ctrAcctInfo.extCompName
  },
  updateCtrAcctDDList(state, list) {
    // state.ctrAcctDDList = value
    state.ctrAcctDDList = Utils.toListWapper(list, {valueField: 'ctrAcctId', descrField: 'acctName'})
  },
  appendCtrAcctDDItem(state, value) {
    // console.log(value)
    // console.log(state.ctrAcctDDList)
    // console.log(state.ctrAcctDDList.find(item => item.descr === value))
    if (!state.ctrAcctDDList.find(item => item.descr === value)) {
      state.ctrAcctDDList.push({
        acctName: value,
        ctrAcctId: value,
        descr: value,
        status: 'A',
        type: 'SND',
        value: value,
        label: value
      })
    }
  },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/user/rspCtrAcctManage.js